(function () {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("9ywsj", function(module, exports) {
parcelRequire("dvSns");
parcelRequire("lzblW");
parcelRequire("hlTU3");
parcelRequire("1yGYc");
parcelRequire("eOC13");
parcelRequire("x58l3");
parcelRequire("kSkug");
parcelRequire("2rkWb");
parcelRequire("gqEIz");
parcelRequire("8llX7");
parcelRequire("auTk3");
parcelRequire("644YJ");
parcelRequire("1089O");
parcelRequire("eTe7K");
parcelRequire("8zOPb");
parcelRequire("7wsQK");
parcelRequire("7L8GP");
parcelRequire("8QXo1");
parcelRequire("lFfIk");
parcelRequire("9r3u0");

});
parcelRegister("dvSns", function(module, exports) {
parcelRequire("lCeY3");
parcelRequire("9uZKt");

});
parcelRegister("lCeY3", function(module, exports) {
parcelRequire("gMX92");
parcelRequire("40Tvy");
parcelRequire("8KFdQ");

});
parcelRegister("gMX92", function(module, exports) {
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
// Converts to:
//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
var $c38f01f81db6fd2d$var$links = document.querySelectorAll(".entry-content a:not(.entry-content .i-gallery__icon a)");
$c38f01f81db6fd2d$var$links.forEach(function(link) {
    var image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img');
    if (image !== null) {
        link.setAttribute("data-fancybox", "");
        if (image.classList.contains("aligncenter")) {
            image.classList.remove("aligncenter");
            link.classList.add("aligncenter");
        }
    }
});

});

parcelRegister("40Tvy", function(module, exports) {
var $2ec2383735de90ef$var$iframes = document.querySelectorAll(".entry-content iframe");
$2ec2383735de90ef$var$iframes.forEach(function(iframe) {
    var _a;
    var iframeSrc = iframe.getAttribute("src");
    if (iframeSrc === null) return;
    if (iframeSrc.indexOf("youtube") !== -1) {
        iframe.classList.add("embed-responsive-item");
        iframe.removeAttribute("height");
        iframe.removeAttribute("width");
        var iframeWrap = document.createElement("div");
        iframeWrap.classList.add("ratio", "ratio-16x9");
        (_a = iframe.parentNode) === null || _a === void 0 || _a.insertBefore(iframeWrap, iframe);
        iframeWrap.appendChild(iframe);
    }
});

});

parcelRegister("8KFdQ", function(module, exports) {
var $65f2987c92668fdf$var$removeWidthHeight = function(selector) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
        element.removeAttribute("width");
        element.removeAttribute("height");
        element === null || element === void 0 || element.style.setProperty("width", null);
        element === null || element === void 0 || element.style.setProperty("height", null);
    });
};
$65f2987c92668fdf$var$removeWidthHeight(".entry-content table");
$65f2987c92668fdf$var$removeWidthHeight(".entry-content tr");
$65f2987c92668fdf$var$removeWidthHeight(".entry-content th");
$65f2987c92668fdf$var$removeWidthHeight(".entry-content td");

});


parcelRegister("9uZKt", function(module, exports) {
// Added submenu button, in order to dropdown submenu
// Style sub-menu__button element to your needs
var $6ea6d05fccdfc608$var$mobileQuery = window.matchMedia("(max-width: 61.999em)");
var $6ea6d05fccdfc608$var$itemsWithSubmenu = document.querySelectorAll(".menu-item-has-children");
$6ea6d05fccdfc608$var$itemsWithSubmenu.forEach(function(item) {
    item.insertAdjacentHTML("beforeend", '<span class="sub-menu__button"></span>');
    var submenuButton = item.querySelector(".sub-menu__button");
    var submenu = item.querySelector(":scope > .sub-menu");
    var handleSubmenu = function(event) {
        if (!$6ea6d05fccdfc608$var$mobileQuery.matches) return;
        event.preventDefault();
        submenu === null || submenu === void 0 || submenu.classList.toggle("--active");
        submenuButton === null || submenuButton === void 0 || submenuButton.classList.toggle("--active");
    };
    submenuButton === null || submenuButton === void 0 || submenuButton.addEventListener("click", handleSubmenu);
});

});


parcelRegister("lzblW", function(module, exports) {

var $5Tf5z = parcelRequire("5Tf5z");
var $fb35ac4911525476$var$_a;
(0, (/*@__PURE__*/$parcel$interopDefault($5Tf5z))).polyfill();
var $fb35ac4911525476$var$scrollUpElement = document.getElementById("c-scroll-up");
if ($fb35ac4911525476$var$scrollUpElement !== null) {
    var $fb35ac4911525476$var$scrollUpSearchButton = $fb35ac4911525476$var$scrollUpElement.querySelector(".c-scroll-up__search-button");
    var $fb35ac4911525476$var$scrollUpSearchClose = $fb35ac4911525476$var$scrollUpElement.querySelector(".c-scroll-up__search-close");
    var $fb35ac4911525476$var$scrollUpButton = $fb35ac4911525476$var$scrollUpElement.querySelector(".c-scroll-up__button");
    var $fb35ac4911525476$var$scrollUpSearchForm_1 = $fb35ac4911525476$var$scrollUpElement.querySelector(".c-scroll-up__search-form");
    var $fb35ac4911525476$var$offsetFromTop_1 = ($fb35ac4911525476$var$_a = Number($fb35ac4911525476$var$scrollUpElement.getAttribute("data-offset-from-top"))) !== null && $fb35ac4911525476$var$_a !== void 0 ? $fb35ac4911525476$var$_a : 100; // if not set default is 100px
    var $fb35ac4911525476$var$isInLimit_1 = function() {
        return document.body.scrollTop > $fb35ac4911525476$var$offsetFromTop_1 || document.documentElement.scrollTop > $fb35ac4911525476$var$offsetFromTop_1;
    };
    var $fb35ac4911525476$var$scrollHandle = function() {
        $fb35ac4911525476$var$scrollUpElement.classList.toggle("--active", $fb35ac4911525476$var$isInLimit_1());
    };
    var $fb35ac4911525476$var$scrollTop = function() {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    window.addEventListener("scroll", $fb35ac4911525476$var$scrollHandle, {
        passive: true
    });
    $fb35ac4911525476$var$scrollUpButton === null || $fb35ac4911525476$var$scrollUpButton === void 0 || $fb35ac4911525476$var$scrollUpButton.addEventListener("click", $fb35ac4911525476$var$scrollTop);
    $fb35ac4911525476$var$scrollUpSearchButton === null || $fb35ac4911525476$var$scrollUpSearchButton === void 0 || $fb35ac4911525476$var$scrollUpSearchButton.addEventListener("click", function() {
        $fb35ac4911525476$var$scrollUpElement.classList.add("--search-open");
        var searchInput = $fb35ac4911525476$var$scrollUpSearchForm_1.querySelector(".f-search__input input");
        searchInput === null || searchInput === void 0 || searchInput.focus();
    });
    $fb35ac4911525476$var$scrollUpSearchClose === null || $fb35ac4911525476$var$scrollUpSearchClose === void 0 || $fb35ac4911525476$var$scrollUpSearchClose.addEventListener("click", function() {
        $fb35ac4911525476$var$scrollUpElement.classList.remove("--search-open");
    });
}

});
parcelRegister("5Tf5z", function(module, exports) {
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    module.exports = {
        polyfill: polyfill
    };
})();

});


parcelRegister("hlTU3", function(module, exports) {

$parcel$export(module.exports, "openModal", function () { return $ca1fc30271ca302f$export$a7f6cffb6b8ba11c; });
$parcel$export(module.exports, "closeModal", function () { return $ca1fc30271ca302f$export$3f6fecd573f3fa48; });
$parcel$export(module.exports, "default", function () { return $ca1fc30271ca302f$export$2e2bcd8739ae039; });
var $ca1fc30271ca302f$var$transitionLength = 300;
var $ca1fc30271ca302f$export$a7f6cffb6b8ba11c = function(modal) {
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
};
var $ca1fc30271ca302f$export$3f6fecd573f3fa48 = function(modal) {
    modal.classList.remove("--open");
    setTimeout(function() {
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
var $ca1fc30271ca302f$var$initTriggers = function() {
    var triggers = document.querySelectorAll("[data-modal-target]");
    triggers.forEach(function(trigger) {
        var _a;
        var modalTarget = document.getElementById((_a = trigger.getAttribute("data-modal-target")) !== null && _a !== void 0 ? _a : "");
        if (modalTarget === null) return;
        trigger.addEventListener("click", function(event) {
            event.preventDefault();
            $ca1fc30271ca302f$export$a7f6cffb6b8ba11c(modalTarget);
        });
    });
};
var $ca1fc30271ca302f$var$initModals = function() {
    var modals = document.querySelectorAll(".c-modal");
    modals.forEach(function(modal) {
        var closeButtons = modal.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", "".concat($ca1fc30271ca302f$var$transitionLength, "ms"));
        closeButtons.forEach(function(closeButton) {
            closeButton.addEventListener("click", function(event) {
                event.preventDefault();
                $ca1fc30271ca302f$export$3f6fecd573f3fa48(modal);
            });
        });
        modal.addEventListener("click", function(event) {
            if (modal == event.target) $ca1fc30271ca302f$export$3f6fecd573f3fa48(modal);
        });
    });
};
// In case needed reinitialize modals
// When something is re rendered
var $ca1fc30271ca302f$var$init = function() {
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
var $ca1fc30271ca302f$export$2e2bcd8739ae039 = $ca1fc30271ca302f$var$init;
$ca1fc30271ca302f$var$init();

});

parcelRegister("eOC13", function(module, exports) {
var $ac933964734433c9$var$herbalsGroups = document.querySelectorAll(".g-herbals");
$ac933964734433c9$var$herbalsGroups.forEach(function(group) {
    var title = group.querySelector(".g-herbals__title");
    title === null || title === void 0 || title.addEventListener("click", function() {
        return group.classList.toggle("--opened");
    });
});

});

parcelRegister("x58l3", function(module, exports) {
var $063710963502915c$var$radioBoxesGroups = document.querySelectorAll(".g-radio-boxes");
$063710963502915c$var$radioBoxesGroups.forEach(function(group) {
    var showMoreButton = group.querySelector(".g-radio-boxes__show-more");
    showMoreButton === null || showMoreButton === void 0 || showMoreButton.addEventListener("click", function(e) {
        e.preventDefault();
        group.classList.toggle("--closed");
    });
});

});

parcelRegister("kSkug", function(module, exports) {
var $f328be1b00e2558f$var$faqs = document.querySelectorAll(".i-faq");
$f328be1b00e2558f$var$faqs.forEach(function(faq) {
    var header = faq.querySelector(".i-faq__header");
    header === null || header === void 0 || header.addEventListener("click", function() {
        faq.classList.toggle("--open");
    });
});

});

parcelRegister("2rkWb", function(module, exports) {
var $1c6e581a12b60051$var$categoryItems = document.querySelectorAll(".i-category");
var $1c6e581a12b60051$var$mobileQuery = window.matchMedia("(max-width: 61.999em)");
$1c6e581a12b60051$var$categoryItems.forEach(function(item) {
    var toggle = item.querySelector(".i-category__toggle");
    var panel = item.querySelector(".main-header-mobile-panel");
    toggle === null || toggle === void 0 || toggle.addEventListener("click", function() {
        item.classList.toggle("--open");
        panel.classList.add("--open");
        if ($1c6e581a12b60051$var$mobileQuery.matches) document.body.classList.add("--disable-scroll");
        var parentPanel = item.closest(".main-header-mobile-panel");
        parentPanel === null || parentPanel === void 0 || parentPanel.scrollTo({
            top: 0
        });
        parentPanel === null || parentPanel === void 0 || parentPanel.classList.add("--child-open");
    });
});

});

parcelRegister("gqEIz", function(module, exports) {
var $bf5ea8c55af5616c$var$userLoginItems = document.querySelectorAll(".i-user-login");
var $bf5ea8c55af5616c$var$mobileQuery = window.matchMedia("(max-width: 61.999em)");
$bf5ea8c55af5616c$var$userLoginItems.forEach(function(userLogin) {
    var button = userLogin.querySelector(".i-user-login__button");
    var close = userLogin.querySelector(".i-user-login__close");
    button === null || button === void 0 || button.addEventListener("click", function(e) {
        if (!$bf5ea8c55af5616c$var$mobileQuery.matches) return;
        e.preventDefault();
        userLogin.classList.add("--open");
        document.body.classList.add("--disable-scroll");
    });
    close === null || close === void 0 || close.addEventListener("click", function() {
        if (!$bf5ea8c55af5616c$var$mobileQuery.matches) return;
        userLogin.classList.remove("--open");
        userLogin.blur();
        document.body.classList.remove("--disable-scroll");
    });
});

});

parcelRegister("8llX7", function(module, exports) {
var $6131503991a1357b$var$toggleItems = document.querySelectorAll(".i-content-toggle");
$6131503991a1357b$var$toggleItems.forEach(function(toggleItem) {
    var toggleWrapper = toggleItem.querySelector(".i-content-toggle__header");
    var toggle = toggleWrapper.querySelector("input[type=checkbox]");
    var content = toggleItem.querySelector(".i-content-toggle__content");
    if (!toggle || !content) return;
    var inputElements = content.querySelectorAll("input, select, textarea");
    var handleInputs = function() {
        inputElements.forEach(function(inputElement) {
            return inputElement.disabled = !toggleItem.classList.contains("--active");
        });
    };
    handleInputs(); // Init
    toggle.addEventListener("change", function() {
        if (toggle.checked) toggleItem.classList.add("--active");
        else toggleItem.classList.remove("--active");
        handleInputs();
    });
});

});

parcelRegister("auTk3", function(module, exports) {
var $7a479e96f9bfc699$var$searchForms = document.querySelectorAll(".f-search");
$7a479e96f9bfc699$var$searchForms.forEach(function(form) {
    var input = form.querySelector(".f-text input");
    var closeButton = form.querySelector(".f-search__close-button");
    closeButton === null || closeButton === void 0 || closeButton.addEventListener("click", function() {
        form.classList.remove("--open");
        document.body.classList.remove("--disable-scroll");
    });
    input === null || input === void 0 || input.addEventListener("focus", function() {
        form.classList.add("--open");
        if (input.closest(".main-header")) document.body.classList.add("--disable-scroll");
    });
    window.addEventListener("click", function(e) {
        var targetElement = e.target;
        if (!form.contains(targetElement)) {
            form.classList.remove("--open");
            document.body.classList.remove("--disable-scroll");
        }
    });
});

});

parcelRegister("644YJ", function(module, exports) {
var $46a6fa6a574edfb6$var$discountForms = document.querySelectorAll(".f-discount");
$46a6fa6a574edfb6$var$discountForms.forEach(function(form) {
    var input = form.querySelector(".f-discount__input input");
    var link = form.querySelector(".f-discount__open-link");
    if (!input) return;
    if (input.value) form.classList.add("--open");
    link === null || link === void 0 || link.addEventListener("click", function(e) {
        e.preventDefault();
        form.classList.add("--open");
    });
});

});

parcelRegister("1089O", function(module, exports) {
var $0bac1e622e046a69$var$mainHeader = document.querySelector(".main-header");
var $0bac1e622e046a69$var$lastScrollTop = window.scrollY || document.documentElement.scrollTop;
window.addEventListener("scroll", function() {
    var st = document.documentElement.scrollTop;
    if (st < $0bac1e622e046a69$var$mainHeader.offsetHeight + 128) return;
    if (st > $0bac1e622e046a69$var$lastScrollTop) $0bac1e622e046a69$var$mainHeader === null || $0bac1e622e046a69$var$mainHeader === void 0 || $0bac1e622e046a69$var$mainHeader.classList.add("--scrolled");
    else if (st < $0bac1e622e046a69$var$lastScrollTop) $0bac1e622e046a69$var$mainHeader === null || $0bac1e622e046a69$var$mainHeader === void 0 || $0bac1e622e046a69$var$mainHeader.classList.remove("--scrolled");
    $0bac1e622e046a69$var$lastScrollTop = st <= 0 ? 0 : st;
}, {
    passive: true
});

});

parcelRegister("8zOPb", function(module, exports) {
var $63e90453b976c86f$var$mainHeaderMobiles = document.querySelectorAll(".main-header-mobile");
$63e90453b976c86f$var$mainHeaderMobiles.forEach(function(mobileHeader) {
    var button = mobileHeader.querySelector(".main-header-mobile__button");
    var panel = document.querySelector(".main-header-mobile__panel");
    button === null || button === void 0 || button.addEventListener("click", function(e) {
        e.preventDefault();
        panel === null || panel === void 0 || panel.classList.add("--open");
        document.body.classList.add("--disable-scroll");
    });
});

});

parcelRegister("7wsQK", function(module, exports) {
var $57a1e68831f57e4b$var$mainHeaderMobilePanels = document.querySelectorAll(".main-header-mobile-panel");
$57a1e68831f57e4b$var$mainHeaderMobilePanels.forEach(function(panel) {
    var closeButtons = panel.querySelectorAll(".main-header-mobile-panel__close");
    var backButton = panel.querySelector(".main-header-mobile-panel__back");
    closeButtons.forEach(function(closeButton) {
        closeButton === null || closeButton === void 0 || closeButton.addEventListener("click", function(e) {
            e.preventDefault();
            $57a1e68831f57e4b$var$mainHeaderMobilePanels.forEach(function(panel) {
                panel.classList.remove("--open");
                document.body.classList.remove("--disable-scroll");
            });
        });
    });
    backButton === null || backButton === void 0 || backButton.addEventListener("click", function(e) {
        e.preventDefault();
        var closestPanel = backButton.closest(".main-header-mobile-panel");
        closestPanel === null || closestPanel === void 0 || closestPanel.classList.remove("--open");
        var parentPanel = closestPanel.parentElement.closest(".main-header-mobile-panel");
        parentPanel === null || parentPanel === void 0 || parentPanel.classList.remove("--child-open");
    });
});

});

parcelRegister("7L8GP", function(module, exports) {
var $5a63a9d0fe61ec3b$var$mainHeadersActions = document.querySelectorAll(".main-header-actions");
var $5a63a9d0fe61ec3b$var$mobileQuery = window.matchMedia("(max-width: 61.999em)");
$5a63a9d0fe61ec3b$var$mainHeadersActions.forEach(function(actionHeader) {
    var cartButton = actionHeader.querySelector(".main-header-actions__cart-button");
    cartButton === null || cartButton === void 0 || cartButton.addEventListener("click", function(e) {
        if (!$5a63a9d0fe61ec3b$var$mobileQuery.matches) return;
        var targetElement = e.target;
        if (!cartButton.querySelector(".main-header-cart__panel")) return;
        if (targetElement.closest(".main-header-cart__panel")) return;
        e.preventDefault();
        var panel = actionHeader.querySelector(".main-header-actions__cart-panel");
        panel === null || panel === void 0 || panel.classList.add("--open");
    });
});

});

parcelRegister("8QXo1", function(module, exports) {

$parcel$export(module.exports, "cartOverviewInit", function () { return $67213ef823bc62a0$export$f6b6adddd76d2d79; });
var $67213ef823bc62a0$export$f6b6adddd76d2d79 = function() {
    var cartOverviewBoxes = document.querySelectorAll(".b-cart-overview");
    cartOverviewBoxes.forEach(function(overview) {
        var products = overview.querySelector(".b-cart-overview__products");
        var productsButton = overview.querySelector(".b-cart-overview__products-button");
        if (!products || !productsButton) return;
        productsButton.addEventListener("click", function(e) {
            var _a;
            e.preventDefault();
            products.classList.toggle("--opened");
            var titleWrapper = productsButton.querySelector(".link__title");
            if (titleWrapper) {
                var tempTitle = titleWrapper.innerText;
                titleWrapper.innerText = (_a = productsButton.dataset.secondTitle) !== null && _a !== void 0 ? _a : titleWrapper.innerText;
                productsButton.dataset.secondTitle = tempTitle;
            }
        });
    });
};
$67213ef823bc62a0$export$f6b6adddd76d2d79();

});

parcelRegister("lFfIk", function(module, exports) {

var $4ElMM = parcelRequire("4ElMM");

var $hlTU3 = parcelRequire("hlTU3");
var $fc599dc9b68aff60$var$radioBoxFields = document.querySelectorAll(".f-radio-box");
$fc599dc9b68aff60$var$radioBoxFields.forEach(function(radioBox) {
    var input = radioBox.querySelector(".f-radio-box__input");
    var options = radioBox.querySelector(".f-radio-box__options select");
    var preventPayment = radioBox.querySelector(".m-prevent-payment");
    var balikovnaModal = radioBox.querySelector(".m-balikovna");
    var preventPaymentConfirm = preventPayment === null || preventPayment === void 0 ? void 0 : preventPayment.querySelector(".m-prevent-payment__confirm");
    if (!input) return;
    radioBox.addEventListener("click", function() {
        if (input.checked) input.checked = !radioBox.classList.contains("--checkbox");
        else input.checked = !(radioBox.classList.contains("--with-parcel") || radioBox.classList.contains("--prevent-payment") || radioBox.classList.contains("--balikovna"));
        if (preventPayment) (0, $hlTU3.openModal)(preventPayment);
        if (balikovnaModal) {
            var balikovnaParcel = radioBox.querySelector(".i-balikovna-parcel");
            if (balikovnaParcel === null || balikovnaParcel === void 0 ? void 0 : balikovnaParcel.classList.contains("d-none")) (0, $hlTU3.openModal)(balikovnaModal);
        }
        input.dispatchEvent(new Event("change"));
    });
    input === null || input === void 0 || input.addEventListener("change", function() {
        $fc599dc9b68aff60$var$radioBoxFields.forEach(function(radioBox) {
            radioBox.dispatchEvent(new Event("deselect"));
            var hiddenInput = radioBox.querySelector('input[type="hidden"]');
            if (radioBox.querySelector('input[type="radio"]:checked') && hiddenInput) hiddenInput.disabled = false;
        });
        if (!options) return;
        options.disabled = !input.checked;
    });
    radioBox.addEventListener("deselect", function() {
        (0, $4ElMM.disableIframeHiddenInputs)();
        if (!options) return;
        options.disabled = true;
    });
    preventPaymentConfirm === null || preventPaymentConfirm === void 0 || preventPaymentConfirm.addEventListener("click", function() {
        if (input) input.checked = true;
        input.dispatchEvent(new Event("change"));
    });
    if (!options) return;
    options.disabled = !input.checked;
});

});
parcelRegister("4ElMM", function(module, exports) {

$parcel$export(module.exports, "disableIframeHiddenInputs", function () { return $362bcc0b8d913c33$export$f3f8971aa9eca6e8; });

var $hlTU3 = parcelRequire("hlTU3");

var $clN8L = parcelRequire("clN8L");
parcelRequire("cEZzR");
var $362bcc0b8d913c33$var$iframeModals = document.querySelectorAll(".m-iframe");
var $362bcc0b8d913c33$var$iframeHiddenInputs = document.querySelectorAll(".f-radio-box__parcel-hidden-input input, .f-radio-box__balikovna-hidden-input input");
var $362bcc0b8d913c33$export$f3f8971aa9eca6e8 = function() {
    $362bcc0b8d913c33$var$iframeHiddenInputs.forEach(function(input) {
        var parentRadioBox = input.closest(".f-radio-box");
        if (parentRadioBox === null || parentRadioBox === void 0 ? void 0 : parentRadioBox.querySelector('input[type="radio"]:checked')) return;
        input.disabled = true;
    });
};
$362bcc0b8d913c33$var$iframeModals.forEach(function(modal) {
    var iframe = modal.querySelector("iframe");
    var url = new URL(iframe === null || iframe === void 0 ? void 0 : iframe.getAttribute("src"));
    var iframeUrl = "".concat(url.protocol, "//").concat(url.hostname);
    console.log(iframeUrl);
    var resultInput = document.querySelector('[id="'.concat(modal.id, '-result"]'));
    if (!resultInput) return;
    var setResultInputValue = function(value) {
        $362bcc0b8d913c33$export$f3f8971aa9eca6e8();
        resultInput.disabled = false;
        resultInput.value = value;
    };
    var setParcelName = function(value) {
        var radioBoxField = document.querySelector('.f-radio-box[data-modal-target="'.concat(modal.id, '"]'));
        if (!radioBoxField) return;
        var radioBoxInput = radioBoxField.querySelector("input");
        if (!radioBoxInput) return;
        radioBoxInput.checked = true;
        radioBoxInput.dispatchEvent(new Event("change"));
        var parcelName = radioBoxField.querySelector(".f-radio-box__parcel-name");
        if (!parcelName) return;
        parcelName.innerText = value;
    };
    var setPacketaItem = function(data) {
        var radioBoxField = document.querySelector('.f-radio-box[data-modal-target="'.concat(modal.id, '"]'));
        if (!radioBoxField) return;
        var radioBoxInput = radioBoxField.querySelector("input");
        if (!radioBoxInput) return;
        radioBoxInput.checked = true;
        radioBoxInput.dispatchEvent(new Event("change"));
        var radioBoxPacketaItem = radioBoxField.querySelector(".f-radio-box__parcel-info");
        console.log(radioBoxPacketaItem);
        if (!radioBoxPacketaItem) return;
        var packetaOptions = {
            name: data.place,
            city: data.city,
            zip: data.zip,
            address: data.nameStreet,
            opening: data.openingHours.tableLong,
            description: data.directions,
            img: data.photo[0].normal
        };
        (0, $clN8L.setPacketaValues)(radioBoxPacketaItem, packetaOptions);
    };
    var iframeListener = function(event) {
        console.log(event.data, !(iframeUrl === event.origin), iframeUrl);
        if (!(iframeUrl === event.origin)) return;
        if (event.data.message === "pickerResult") {
            setResultInputValue(event.data.id);
            setParcelName(event.data.point.address);
        } else if (event.data.dpdWidget) {
            setResultInputValue(event.data.dpdWidget.id);
            setParcelName(event.data.dpdWidget.pickupPointResult);
        } else if (event.data.packetaSelectedId) {
            setResultInputValue(event.data.packetaSelectedId);
            setPacketaItem(event.data.packetaSelectedData);
        }
        (0, $hlTU3.closeModal)(modal);
    };
    window.addEventListener("message", iframeListener);
});

});
parcelRegister("clN8L", function(module, exports) {

$parcel$export(module.exports, "setPacketaValues", function () { return $8fdd906d3406a1cb$export$2eca083f0a7e4f64; });
var $8fdd906d3406a1cb$var$packetaParcelItems = document.querySelectorAll(".i-packeta-parcel");
$8fdd906d3406a1cb$var$packetaParcelItems.forEach(function(item) {
    var _a;
    var radio = item.closest(".f-radio-box");
    var radioInput = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__input");
    var hiddenInputs = document.querySelectorAll(".f-radio-box__parcel-hidden-input");
    var resultInput = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__parcel-hidden-input input");
    var packetaApiKey = item.dataset.packetaApi;
    var packetaOptions = JSON.parse((_a = item.dataset.packetaOptions) !== null && _a !== void 0 ? _a : "");
    var countrySelect = document.querySelector(".s-shipping-payment__country-select select");
    var changeParcelLink = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__link");
    var disableIframeHiddenInputs = function() {
        hiddenInputs.forEach(function(input) {
            return input.disabled = true;
        });
    };
    var setResultInputValue = function(value) {
        disableIframeHiddenInputs();
        resultInput.disabled = false;
        resultInput.value = value;
    };
    var packetaCallback = function(point) {
        item.classList.add("d-none");
        changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.add("--hidden");
        if (radioInput) radioInput.checked = false;
        if (point) {
            changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.remove("--hidden");
            item.classList.remove("d-none");
            if (radioInput) radioInput.checked = true;
            if (resultInput) {
                var packetaInfo_1 = {
                    id: point.id,
                    name: point.name,
                    place: point.place,
                    street: point.street,
                    city: point.city,
                    zip: point.zip
                };
                setResultInputValue(JSON.stringify(packetaInfo_1));
            }
            var packetaInfo = {
                name: point.place,
                city: point.city,
                zip: point.zip,
                address: point.nameStreet,
                opening: point.openingHours.tableLong,
                description: point.directions,
                img: point.photo[0].normal
            };
            $8fdd906d3406a1cb$export$2eca083f0a7e4f64(item, packetaInfo);
        }
        radioInput.dispatchEvent(new Event("change"));
    };
    radio === null || radio === void 0 || radio.addEventListener("click", function() {
        var country = countrySelect ? countrySelect.selectedOptions[0].value : "";
        if (country) packetaOptions.country = country.toLowerCase();
        if (item.classList.contains("d-none")) Packeta.Widget.pick(packetaApiKey, packetaCallback, packetaOptions);
        else if (radioInput) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event("change"));
        }
    });
    changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.addEventListener("click", function(e) {
        e.preventDefault();
        Packeta.Widget.pick(packetaApiKey, packetaCallback, packetaOptions);
    });
    countrySelect === null || countrySelect === void 0 || countrySelect.addEventListener("change", function() {
        disableIframeHiddenInputs();
        setResultInputValue("");
        $8fdd906d3406a1cb$export$2eca083f0a7e4f64(item, null, true);
        item.classList.add("d-none");
        changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.add("--hidden");
    });
});
var $8fdd906d3406a1cb$export$2eca083f0a7e4f64 = function(item, packetaOptions, clear) {
    if (clear === void 0) clear = false;
    var nameElement = item.querySelector(".i-packeta-parcel__name");
    var cityElement = item.querySelector(".i-packeta-parcel__city");
    var zipElement = item.querySelector(".i-packeta-parcel__zip");
    var addressElement = item.querySelector(".i-packeta-parcel__address");
    var openingElement = item.querySelector(".i-packeta-parcel__opening-hours-table");
    var descriptionElement = item.querySelector(".i-packeta-parcel__description");
    var imgElement = item.querySelector(".i-packeta-parcel__image img");
    if (clear) {
        if (nameElement) nameElement.innerHTML = "";
        if (cityElement) cityElement.innerHTML = "";
        if (zipElement) zipElement.innerHTML = "";
        if (addressElement) addressElement.innerHTML = "";
        if (openingElement) openingElement.innerHTML = "";
        if (descriptionElement) descriptionElement.innerHTML = "";
        if (imgElement) imgElement.src = "";
        return;
    }
    if (nameElement) nameElement.innerHTML = packetaOptions.name;
    if (cityElement) cityElement.innerHTML = packetaOptions.city;
    if (zipElement) zipElement.innerHTML = packetaOptions.zip;
    if (addressElement) addressElement.innerHTML = packetaOptions.address;
    if (openingElement) openingElement.innerHTML = packetaOptions.opening;
    if (descriptionElement) descriptionElement.innerHTML = packetaOptions.description;
    if (imgElement) imgElement.src = packetaOptions.img;
};

});

parcelRegister("cEZzR", function(module, exports) {

var $hlTU3 = parcelRequire("hlTU3");
var $9378fc71f7ce29f1$var$balikovnaParcelItems = document.querySelectorAll(".i-balikovna-parcel");
$9378fc71f7ce29f1$var$balikovnaParcelItems.forEach(function(item) {
    var radio = item.closest(".f-radio-box");
    var radioInput = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__input");
    var hiddenInputs = document.querySelectorAll(".f-radio-box__balikovna-hidden-input");
    var resultInput = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__balikovna-hidden-input input");
    var countrySelect = document.querySelector(".s-shipping-payment__country-select select");
    var changeParcelLink = radio === null || radio === void 0 ? void 0 : radio.querySelector(".f-radio-box__link");
    var balikovnaModal = radio === null || radio === void 0 ? void 0 : radio.querySelector(".m-balikovna");
    var loadBalikovnaIframe = function() {
        var _a;
        var iframe = balikovnaModal === null || balikovnaModal === void 0 ? void 0 : balikovnaModal.querySelector("iframe");
        if (iframe && !iframe.classList.contains("--loaded")) {
            iframe.src = (_a = iframe.getAttribute("defer-src")) !== null && _a !== void 0 ? _a : "";
            iframe.classList.add("--loaded");
        }
    };
    var disableIframeHiddenInputs = function() {
        hiddenInputs.forEach(function(input) {
            return input.disabled = true;
        });
    };
    var setResultInputValue = function(value) {
        if (!resultInput) return;
        disableIframeHiddenInputs();
        resultInput.disabled = false;
        resultInput.value = value;
    };
    var balikovnaCallback = function(point) {
        item.classList.add("d-none");
        changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.add("--hidden");
        if (radioInput) radioInput.checked = false;
        if (point) {
            changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.remove("--hidden");
            item.classList.remove("d-none");
            if (radioInput) radioInput.checked = true;
            if (resultInput) {
                var balikovnaInfo_1 = {
                    id: point.id,
                    name: point.name,
                    address: point.address,
                    description: point.description,
                    street: point.street,
                    city: point.city,
                    zip: point.zip
                };
                setResultInputValue(JSON.stringify(balikovnaInfo_1));
            }
            var balikovnaInfo = {
                name: point.name,
                city: point.city,
                zip: point.zip,
                address: point.address,
                openingHours: point.opening_hours,
                description: point.description
            };
            $9378fc71f7ce29f1$export$4f4391d65a2dfb97(item, balikovnaInfo);
            if (radioInput) {
                radioInput.checked = true;
                radioInput.dispatchEvent(new Event("change"));
            }
        }
        if (balikovnaModal) (0, $hlTU3.closeModal)(balikovnaModal);
    };
    radio === null || radio === void 0 || radio.addEventListener("click", function() {
        /* const country = countrySelect ? countrySelect.selectedOptions[0].value : ""
        if (country) balikovnaOptions.country = country.toLowerCase() */ if (item.classList.contains("d-none")) loadBalikovnaIframe();
        else if (radioInput) {
            radioInput.checked = true;
            radioInput.dispatchEvent(new Event("change"));
        }
    });
    changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.addEventListener("click", function(e) {
        e.preventDefault();
        loadBalikovnaIframe();
        if (balikovnaModal) (0, $hlTU3.openModal)(balikovnaModal);
    });
    countrySelect === null || countrySelect === void 0 || countrySelect.addEventListener("change", function() {
        disableIframeHiddenInputs();
        setResultInputValue("");
        $9378fc71f7ce29f1$export$4f4391d65a2dfb97(item, null, true);
        item.classList.add("d-none");
        changeParcelLink === null || changeParcelLink === void 0 || changeParcelLink.classList.add("--hidden");
    });
    window.addEventListener("message", function(event) {
        if (event.data.message === "pickerResult") {
            console.log(event.data);
            balikovnaCallback(event.data.point);
        }
    });
});
var $9378fc71f7ce29f1$export$4f4391d65a2dfb97 = function(item, balikovnaOptions, clear) {
    if (clear === void 0) clear = false;
    var nameElement = item.querySelector(".i-balikovna-parcel__name");
    var cityElement = item.querySelector(".i-balikovna-parcel__city");
    var zipElement = item.querySelector(".i-balikovna-parcel__zip");
    var addressElement = item.querySelector(".i-balikovna-parcel__address");
    var openingElement = item.querySelector(".i-balikovna-parcel__opening-hours-table");
    var descriptionElement = item.querySelector(".i-balikovna-parcel__description");
    if (clear) {
        if (nameElement) nameElement.innerHTML = "";
        if (cityElement) cityElement.innerHTML = "";
        if (zipElement) zipElement.innerHTML = "";
        if (addressElement) addressElement.innerHTML = "";
        if (openingElement) openingElement.innerHTML = "";
        if (descriptionElement) descriptionElement.innerHTML = "";
        return;
    }
    if (nameElement) nameElement.innerHTML = balikovnaOptions.name;
    if (cityElement) cityElement.innerHTML = balikovnaOptions.city;
    if (zipElement) zipElement.innerHTML = balikovnaOptions.zip;
    if (addressElement) addressElement.innerHTML = balikovnaOptions.address;
    if (openingElement) $9378fc71f7ce29f1$var$setOpeningHours(openingElement, balikovnaOptions.openingHours);
    if (descriptionElement) descriptionElement.innerHTML = balikovnaOptions.description;
};
var $9378fc71f7ce29f1$var$setOpeningHours = function(tableWrapper, openingHours) {
    if (!tableWrapper) return;
    var days = [
        "Pond\u011Bl\xed",
        "\xdater\xfd",
        "St\u0159eda",
        "\u010Ctvrtek",
        "P\xe1tek",
        "Sobota",
        "Ned\u011Ble"
    ];
    var openningHoursElement = document.createDocumentFragment();
    var table = openningHoursElement.appendChild(document.createElement("table"));
    table.setAttribute("cellpadding", "5");
    days.forEach(function(day, index) {
        var openingObject = openingHours[index];
        var tableRow = table.appendChild(document.createElement("tr"));
        var tableDataName = tableRow.appendChild(document.createElement("td")).appendChild(document.createElement("strong"));
        tableDataName.innerHTML = "".concat(day, ": ");
        var tableDataOpening = tableRow.appendChild(document.createElement("td"));
        if (openingObject) tableDataOpening.innerHTML = "".concat(openingObject[0]["od"], "  - ").concat(openingObject[0]["do"]);
        else tableDataOpening.innerHTML = "Zav\u0159eno";
    });
    tableWrapper.innerHTML = "";
    tableWrapper.appendChild(table);
};

});



parcelRegister("9r3u0", function(module, exports) {

var $hE5wo = parcelRequire("hE5wo");

var $iXJft = parcelRequire("iXJft");

var $9BQeR = parcelRequire("9BQeR");

var $f1V7L = parcelRequire("f1V7L");

var $9WVoU = parcelRequire("9WVoU");
var $6de956576221b1de$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6de956576221b1de$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6de956576221b1de$var$carts = document.querySelectorAll(".s-cart");
$6de956576221b1de$var$carts.forEach(function(cart) {
    var totalPrice = new (0, $hE5wo.TotalPriceItem)(cart.querySelector(".i-total-price"));
    var items = cart.querySelectorAll(".i-cart");
    items.forEach(function(item) {
        var _a, _b;
        var cartItem = new (0, $iXJft.CartItem)(item);
        var productId = (_a = item.dataset.productId) !== null && _a !== void 0 ? _a : null;
        var mass = (_b = item.dataset.mass) !== null && _b !== void 0 ? _b : null;
        var counterInput = item.querySelector(".c-counter__input");
        var deleteButton = item.querySelector(".--js-cart-remove");
        counterInput === null || counterInput === void 0 || counterInput.addEventListener("change", function() {
            return $6de956576221b1de$var$__awaiter(void 0, void 0, void 0, function() {
                var quantity, response, _a, data;
                return $6de956576221b1de$var$__generator(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            if (!productId) {
                                console.log("product id is missing");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            quantity = Number(counterInput.value);
                            cart.classList.add("--loading");
                            if (!(quantity > 0)) return [
                                3 /*break*/ ,
                                2
                            ];
                            return [
                                4 /*yield*/ ,
                                (0, $9BQeR.cartApi).change(productId, mass, quantity)
                            ];
                        case 1:
                            _a = _b.sent();
                            return [
                                3 /*break*/ ,
                                4
                            ];
                        case 2:
                            return [
                                4 /*yield*/ ,
                                (0, $9BQeR.cartApi).delete(productId, mass)
                            ];
                        case 3:
                            _a = _b.sent();
                            _b.label = 4;
                        case 4:
                            response = _a;
                            if (!response.ok) return [
                                3 /*break*/ ,
                                6
                            ];
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 5:
                            data = _b.sent();
                            if (!data.success) {
                                cart.classList.remove("--loading");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                            (0, $9WVoU.rerenderProgresses)(data.progress.remaining, Number(data.progress.percentage));
                            if (quantity > 0) {
                                cartItem.setPriceBase(data.product.base);
                                cartItem.setPriceMain(data.product.main);
                                cartItem.setPriceBefore(data.product.before);
                            } else item.remove();
                            console.log(totalPrice);
                            totalPrice.setBaseValue(data.totalPrice.base);
                            totalPrice.setMainValue(data.totalPrice.main);
                            _b.label = 6;
                        case 6:
                            cart.classList.remove("--loading");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
        deleteButton === null || deleteButton === void 0 || deleteButton.addEventListener("click", function(event) {
            return $6de956576221b1de$var$__awaiter(void 0, void 0, void 0, function() {
                var response, data;
                return $6de956576221b1de$var$__generator(this, function(_a) {
                    switch(_a.label){
                        case 0:
                            event.preventDefault();
                            cart.classList.add("--loading");
                            if (!productId) {
                                console.log("product id is missing");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            return [
                                4 /*yield*/ ,
                                (0, $9BQeR.cartApi).delete(productId, mass)
                            ];
                        case 1:
                            response = _a.sent();
                            if (!response.ok) return [
                                3 /*break*/ ,
                                3
                            ];
                            return [
                                4 /*yield*/ ,
                                response.json()
                            ];
                        case 2:
                            data = _a.sent();
                            if (!data.success) {
                                cart.classList.remove("--loading");
                                return [
                                    2 /*return*/ 
                                ];
                            }
                            if (data.headerDropdown) (0, $f1V7L.rerenderCartDropdown)(data.headerDropdown, data.totalPrice.main, data.amount);
                            if (data.progress) (0, $9WVoU.rerenderProgresses)(data.progress.remaining, Number(data.progress.percentage));
                            item.remove();
                            totalPrice.setBaseValue(data.totalPrice.base);
                            totalPrice.setMainValue(data.totalPrice.main);
                            _a.label = 3;
                        case 3:
                            cart.classList.remove("--loading");
                            return [
                                2 /*return*/ 
                            ];
                    }
                });
            });
        });
    });
});

});
parcelRegister("hE5wo", function(module, exports) {

$parcel$export(module.exports, "TotalPriceItem", function () { return $cd8a748b5d3493c3$export$7e4d2bf00cc4b98e; });
var $cd8a748b5d3493c3$export$7e4d2bf00cc4b98e = /** @class */ function() {
    function TotalPriceItem(totalPriceItem) {
        var _a, _b;
        this.totalPriceItem = totalPriceItem;
        this.baseValue = (_a = totalPriceItem === null || totalPriceItem === void 0 ? void 0 : totalPriceItem.querySelector(".i-total-price__value-base")) !== null && _a !== void 0 ? _a : null;
        this.mainValue = (_b = totalPriceItem === null || totalPriceItem === void 0 ? void 0 : totalPriceItem.querySelector(".i-total-price__value-main")) !== null && _b !== void 0 ? _b : null;
    }
    TotalPriceItem.prototype.setBaseValue = function(value) {
        console.log(value, this.baseValue);
        if (!this.baseValue) return;
        this.baseValue.innerHTML = value;
    };
    TotalPriceItem.prototype.setMainValue = function(value) {
        console.log(value, this.mainValue);
        if (!this.mainValue) return;
        this.mainValue.innerHTML = value;
    };
    return TotalPriceItem;
}();

});

parcelRegister("iXJft", function(module, exports) {

$parcel$export(module.exports, "CartItem", function () { return $dce0d615728ab29b$export$924278cdd4995b95; });
var $dce0d615728ab29b$export$924278cdd4995b95 = /** @class */ function() {
    function CartItem(cartItem) {
        var _a, _b, _c;
        this.cartItem = cartItem;
        this.priceBase = (_a = cartItem === null || cartItem === void 0 ? void 0 : cartItem.querySelector(".i-price__base")) !== null && _a !== void 0 ? _a : null;
        this.priceMain = (_b = cartItem === null || cartItem === void 0 ? void 0 : cartItem.querySelector(".i-price__main")) !== null && _b !== void 0 ? _b : null;
        this.priceBefore = (_c = cartItem === null || cartItem === void 0 ? void 0 : cartItem.querySelector(".i-price__before")) !== null && _c !== void 0 ? _c : null;
    }
    CartItem.prototype.setPriceBase = function(value) {
        if (!this.priceBase) return;
        this.priceBase.innerHTML = value;
    };
    CartItem.prototype.setPriceMain = function(value) {
        if (!this.priceMain) return;
        this.priceMain.innerHTML = value;
    };
    CartItem.prototype.setPriceBefore = function(value) {
        if (!this.priceBefore) return;
        this.priceBefore.innerHTML = value;
    };
    return CartItem;
}();

});

parcelRegister("9BQeR", function(module, exports) {

$parcel$export(module.exports, "cartApi", function () { return $6ff0174b1648b270$export$7352aab6d7a2d16f; });
var $6ff0174b1648b270$var$__assign = undefined && undefined.__assign || function() {
    $6ff0174b1648b270$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $6ff0174b1648b270$var$__assign.apply(this, arguments);
};
var $6ff0174b1648b270$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $6ff0174b1648b270$var$__generator = undefined && undefined.__generator || function(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
var $6ff0174b1648b270$var$CartApi = /** @class */ function() {
    function CartApi() {
        this.responseSettings = {
            method: "POST"
        };
    }
    CartApi.prototype.makeRequest = function(url, options) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            var response, error_1;
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        _a.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4 /*yield*/ ,
                            fetch(url, $6ff0174b1648b270$var$__assign($6ff0174b1648b270$var$__assign({}, this.responseSettings), options))
                        ];
                    case 1:
                        response = _a.sent();
                        console.log(response);
                        if (!response.ok) throw new Error("Request failed with status ".concat(response.status));
                        return [
                            2 /*return*/ ,
                            response
                        ];
                    case 2:
                        error_1 = _a.sent();
                        console.error("An error occurred:", error_1);
                        throw error_1; // Propagate the error for handling at a higher level if needed
                    case 3:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    // Adds a product to the cart
    CartApi.prototype.add = function(productId, mass, quantity) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/add-product/".concat(productId, "/").concat(mass, "/").concat(quantity), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Changes the quantity of a product in the cart
    CartApi.prototype.change = function(productId, mass, quantity) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/change-product-quantity/".concat(productId, "/").concat(mass, "/").concat(quantity), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Deletes a product from the cart
    CartApi.prototype.delete = function(productId, mass) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/delete-product/".concat(productId, "/").concat(mass), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Deletes all products from the cart
    CartApi.prototype.deleteAll = function() {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/delete-all", {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Processes shipping and delivery for the cart
    CartApi.prototype.shippingAndDelivery = function(body) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            var options;
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        options = {
                            body: body
                        };
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/shipping-and-delivery", options)
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    // Verify if email is already registered
    CartApi.prototype.verifyRegisteredEmail = function(email) {
        return $6ff0174b1648b270$var$__awaiter(this, void 0, void 0, function() {
            return $6ff0174b1648b270$var$__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.makeRequest("/cart/verify-registered-email/".concat(email), {
                                headers: [
                                    [
                                        "X-Requested-With",
                                        "XMLHttpRequest"
                                    ]
                                ]
                            })
                        ];
                    case 1:
                        return [
                            2 /*return*/ ,
                            _a.sent()
                        ];
                }
            });
        });
    };
    return CartApi;
}();
var $6ff0174b1648b270$export$7352aab6d7a2d16f = new $6ff0174b1648b270$var$CartApi();

});



})();
//# sourceMappingURL=main.2b4ff2e1.js.map
